import { render, staticRenderFns } from "./TicketsSelector.vue?vue&type=template&id=3af40c75"
import script from "./TicketsSelector.vue?vue&type=script&lang=js"
export * from "./TicketsSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports